<ras-page>
	<main>
		<h1>Self-storage facility standards</h1>

		<p class="lead">A visit to any of our self storage facilities will demonstrate that we maintain consistently high standards.</p>

		<nav>
			<ul>
				<li><a routerLink="./" fragment="facility-standards">Facility standards</a></li>
				<li><a routerLink="./" fragment="building-standards">Building standards</a></li>
				<li><a routerLink="./" fragment="hygienic-storage-sites">Hygienic storage sites</a></li>
				<li><a routerLink="./" fragment="pest-control">Pest control</a></li>
				<li><a routerLink="./" fragment="fire-compliance">Fire compliance</a></li>
			</ul>
		</nav>

		<h2 id="facility-standards">Facility standards</h2>

		<p>Know that the place where your belongings are stored is run by South Africa’s leading self-storage management company with decades of experience. The management company together with the property owners are continually striving to improve the Rent-A-Store offering by managing and funding facility improvements, upkeep, staff training and systems development on an on-going basis.  We take no shortcuts  when it comes to providing the facility and service excellence expected at Rent-A-Store.</p>

		<h2 id="building-standards">Building standards</h2>

		<h3>Secure storage</h3>

		<p>Rent-A-Store buildings are custom designed and meticulously built for self storage purposes. The building designs primarily take into consideration, the safeguarding of stored items from environmental factors, safety and security of goods and our customers and also incorporate quality security systems and  components.  Eg. Each door is fitted with a unique tamper proof pad bolt system and some newer developments have door monitoring systems installed.</p>

		<h3>Accessible</h3>

		<p>Drive right up to your unit, and conveniently load your goods. We offer predominantly premium, ground level unit access.</p>
		<p>Passenger and/or goods lifts are provided to make above ground storage units easily accessible with spacious passages.</p>
		<p>Roadways are designed to accommodate large furniture, container and commercial trucks with ease.</p>

		<h3>Wide range of unit sizes</h3>

		<p>Select a space that’s right for your storage needs. We offer a variety of sizes at our various facilities ranging from 1sqm to 54sqm. Check unit sizes by clicking on GET A QUOTE, here you will get an indication of storage unit capacities and related rentals. Read our Packing and Moving Tips for information on how to optimize the use of your storage space.</p>

		<h3>Secure</h3>

		<p>Store your belongings with peace of mind. State-of-the-art security systems are installed at all our sites, and we strictly enforce rules and procedures to maintain a high secure environment. Visit our Security page for detailed information.</p>

		<h3>User friendly</h3>

		<p>At our storage sites you will find five star clean toilet facilities with wash basins, hand soap and  paper towels where you may freshen up and relax at your convenience.</p>


		<h2 id="hygienic-storage-sites">Hygienic storage sites</h2>

		<h3>Clean and tidy</h3>

		<p>We follow a daily maintenance schedule to ensure that our sites are consistently clean and tidy. This includes attention to roadways, gardens, communal amenities and roller doors.</p>

		<h3>Environmentally responsible</h3>

		<p>Recycling stations are conveniently situated at all our premises.</p>


		<h2 id="pest-control">Pest control</h2>

		<p>Pest control professionals will be brought in should a problem arise.</p>

		<h3>Termites</h3>

		<p>All stores have been pre-treated against termite infestation.</p>

		<h3>Rodents</h3>

		<p>Storage of perishable food items which are a major attraction of rodents is strictly prohibited. Our premises are kept clean and tidy to avoid attracting vermin.</p>

		<h3>Insects</h3>

		<p>Insects may enter storage units via necessary ventilation openings. Where this is a concern, we advise tenants to use a fogger inside their unit to safeguard against this. These are available through Rent-A-Store Packing Supplies.</p>


		<h2 id="fire-compliance">Fire compliance</h2>

		<p>Our facilities have been approved to ensure compliance with fire safety regulations and our structures are designed to minimise the spread of fire.</p>
		<p>Premises are maintained and equipped as per the national building regulations.</p>
	</main>

</ras-page>
